import { Modal as SemanticModal } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { GetHistoricalMonthlyReconciliations } from "../../graphql/dashboard";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HMRRow } from "./HMRRow";
import { HMRByEmailModal } from "./HMRByEmailModal";
import CustomModal from "../../components/configuracion/components/customModal";
import ScfoButton from "../../components/shared/ScfoButton";
import "./hmrModal.scss";

const SKELETON_MONTHS = 6;

const HMRMonthlySkeleton = ({ label }) => (
  <div aria-busy="true" aria-live="polite">
    <span className="hmr-skeleton-visually-hidden">{label}</span>
    <div className="hmr-modal-monthly-list">
      {Array.from({ length: SKELETON_MONTHS }, (_, index) => (
        <div
          key={index}
          className="hmr-month-card hmr-month-card--skeleton"
          aria-hidden="true"
        >
          <div className="hmr-month-card__title-row">
            <span className="hmr-skeleton-line hmr-skeleton-line--period" />
            <span className="hmr-skeleton-line hmr-skeleton-line--link" />
          </div>
          <div className="hmr-month-card__progress-block">
            <span className="hmr-skeleton-line hmr-skeleton-line--bar" />
            <span className="hmr-skeleton-line hmr-skeleton-line--status" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const HMRModal = ({
  open,
  setOpen
}) => {
  const { t } = useTranslation("header");
  const { selectedCompany } = useSelector((state) => state.companyList);
  const getHistoricalMonthlyReconciliations = GetHistoricalMonthlyReconciliations(
    { companyId: selectedCompany.id },
    { pause: !open }
  );

  const [view, setView] = useState("monthly"); // 'monthly' | 'matchSource'
  const monthlyRows = getHistoricalMonthlyReconciliations.data?.getHistoricalMonthlyReconciliations;
  const showMonthlySkeleton =
    view === "monthly" &&
    !getHistoricalMonthlyReconciliations.error &&
    !Array.isArray(monthlyRows);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!open) return;
    getHistoricalMonthlyReconciliations.reExecuteQuery({ requestPolicy: "network-only" });
  }, [selectedCompany.id, open]);

  useEffect(() => {
    if (!open) setView("monthly");
  }, [open]);

  const handleClose = () => setOpen(false);

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      dimmer="blurring"
      size="large"
      hideActions
      classNameModal="hmr-reconciliation-modal"
      classNameContent="hmr-modal-content-wrapper"
      closeOnDimmerClick
      closeOnEscape
      renderHeader={
        <SemanticModal.Header>
          <div className="hmr-modal-header">
            <h2 className="hmr-modal-header__title">{t("reconciliation.progressTitle")}</h2>
            {view === "monthly" && (
              <ScfoButton
                type="button"
                variant="ghost"
                size="sm"
                className="hmr-modal-header__action"
                onClick={() => setView("matchSource")}
              >
                {t("reconciliation.matchBreakdown")}
              </ScfoButton>
            )}
          </div>
        </SemanticModal.Header>
      }
      content={
        view === "monthly" ? (
          showMonthlySkeleton ? (
            <HMRMonthlySkeleton label={t("reconciliation.loading")} />
          ) : (
            <div className="hmr-modal-monthly-list">
              {(monthlyRows || []).map((hmr) => (
                <HMRRow key={hmr.period} hmr={hmr} onRequestClose={handleClose} />
              ))}
            </div>
          )
        ) : (
          <HMRByEmailModal onBack={() => setView("monthly")} />
        )
      }
    />
  );
};
